var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    {
      staticClass: "fadeIn card-radius m-0",
      class: [_vm.cardClass, { "overflow-hidden": !_vm.expanded }],
      attrs: {
        "header-class": ["row-radius", _vm.headerClass],
        "footer-class": "row-bottom-radius",
        "body-class": "p-0 mt-n1",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-between user-select-none",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-items-center",
                        class: {
                          "cursor-pointer":
                            _vm.collapsable && !_vm.disableToggle,
                        },
                        on: {
                          click: function ($event) {
                            !_vm.disableToggle ? _vm.toggle() : null
                          },
                        },
                      },
                      [
                        _vm.icon
                          ? _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, size: _vm.iconSize },
                            })
                          : _vm._e(),
                        _c("h4", { staticClass: "p-0 my-0 mx-2" }, [
                          _vm._v(_vm._s(_vm.title)),
                        ]),
                        _vm._t("header-right"),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _vm._t("header-left"),
                        _vm.collapsable
                          ? _c(
                              "b-btn",
                              {
                                class: [
                                  "d-print-none py-0 px-2 m-0 no-outline",
                                  _vm.toggleButtonClass,
                                ],
                                attrs: {
                                  variant: "transparent",
                                  disabled: _vm.disableToggle,
                                },
                                on: { click: _vm.toggle },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: `chevron-${
                                      _vm.expanded ? "up" : "down"
                                    }`,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          _vm.$slots.footer
            ? {
                key: "footer",
                fn: function () {
                  return [_vm._t("footer")]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "b-collapse",
        {
          class: _vm.collapseClass,
          model: {
            value: _vm.expanded,
            callback: function ($$v) {
              _vm.expanded = $$v
            },
            expression: "expanded",
          },
        },
        [
          _c(
            "b-overlay",
            {
              staticClass: "h-100",
              attrs: {
                show: _vm.loading,
                blur: "1rem",
                opacity: "0.6",
                rounded: "lg",
                variant: "transparent",
              },
            },
            [_c("div", { class: _vm.containerClass }, [_vm._t("default")], 2)]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }